import {useState} from "react";
import { emailForm } from "../../../lib/api";
import {toast} from "react-toastify";
import { useI18n } from '../../../i18n/context';

const CardForm = () => {
  const { t } = useI18n();

  const [msg, setMsg] = useState('');
  const [email, setEma] = useState('');
  const [name, setNam] = useState('');

  const handleSubmit = async () => {
    try {
      const result = await emailForm({ name, email, msg });
      toast(result.message || t('containers.contact.success'));
    } catch (error) {
      const msgText = error?.message || error.toString();
      toast(`${t('containers.contact.errorPrefix')} ${msgText}`);
    }
  };

  return (
    <div className="card-body">
        <div className="mb-3 mt-10p">
          <input onChange={e => setNam(e.target.value)} type="text" className="form-control" style={{ background: 'rgba(12,16,32,0.75)', color: '#fff', borderColor: 'rgba(111,139,255,0.35)' }} placeholder={t('containers.contact.name')} aria-label={t('containers.contact.name')} />
        </div>
        <div className="mb-3">
          <input onChange={e => setEma(e.target.value)} type="email" className="form-control" style={{ background: 'rgba(12,16,32,0.75)', color: '#fff', borderColor: 'rgba(111,139,255,0.35)' }} placeholder={t('containers.contact.email')} aria-label={t('containers.contact.email')} />
        </div>
        <div className="mb-3">
          <textarea onChange={e => setMsg(e.target.value)} name="Message" className="form-control" style={{ background: 'rgba(12,16,32,0.75)', color: '#fff', borderColor: 'rgba(111,139,255,0.35)' }} id="Message" placeholder={t('containers.contact.message')} cols="30" rows="10"/>
        </div>

        <div className="text-center">
          <button onClick={()=>handleSubmit()} className="pixel-btn w-100 my-4 mb-2">{t('containers.contact.submit')}</button>
        </div>


    </div>
  );
}

export default CardForm;
